import './Footer.css'

const Footer = () => {
  return (
    <footer className='flex jcc'>
      <div className='wrap1'>
        <div className='flex sb'>
          <div>
            <h4>Компания</h4>
            <p>
              <a href='#main'>Главная</a>
            </p>
            <p>
              <a href='#about'>О нас</a>
            </p>
            <p>
              <a href='#service'>Услуги</a>
            </p>
            <p>
              <a href='#servers'>Оборудование</a>
            </p>
            <p>
              <a href='#works'>Работы</a>
            </p>
            <p>
              <a href='#partners'>Партнеры</a>
            </p>
          </div>
          <div>
            <h4>Правовая информация</h4>
            <p>
              <a href='#f'>Политика конфинденциальности</a>
            </p>
            <p>
              <a href='#f'>Cookie</a>
            </p>
            <p>
              <a target='_blank' rel='noreferrer' href='https://storyset.com/technology'>
                Technology illustrations by Storyset
              </a>
            </p>
          </div>
          <div />
          <div>
            <div>
              <div className='info'>
                <h4>RMe</h4>
                <p>
                  <a href='tel:+79313486968'>
                    +7&nbsp;931&nbsp;348-69-68
                  </a>
                </p>
                <div>
                  <a href='https://t.me/reflect_me_channel' target='_blank' rel='noreferrer' className='social'>
                    <img alt='' src='/images/social1.svg' />
                  </a>
                  <a href='https://wa.me/74951234567' target='_blank' className='social' rel='noreferrer'>
                    <img alt='' src='/images/social2.svg' />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
